export const TOKEN = 'ANAKIN_TOKEN';
export const REFRESH_TOKEN = 'ANAKIN_REFRESH_TOKEN';
export const USERNAME = 'ANAKIN_USERNAME';
export const FAVICON = 'ANAKIN_FAVICON';
export const HAS_LOGGED = 'ANAKIN_HAS_LOGGED';
export const REGISTER_TAB = 'ANAKIN_REGISTER_TAB';
export const CHECK_FIRST_TAB = 'ANAKIN_CHECK_FIRST_TAB';
export const TOKEN_LAST_UPDATE_TIME = 'TOKEN_LAST_UPDATE_TIME';
export const IS_FIRST_LOGIN = Symbol('is_first_login');
